export const CONSTANTS = Object.freeze({
  USER_TOKEN: 'USER_TOKEN',
  SELECTED_USER: 'SELECTED_USER',
  SELECTED_DASHBOARD_USER: 'SELECTED_DASHBOARD_USER',
  CURRENT_USER: 'CURRENT_USER',
  CURRENT_USER_TIER: 'CURRENT_USER_TIER',
  USER_TIERS: ["admin", "active", "passive"],
})
